import * as React from "react";
import { Accordion, AccordionTitleProps } from "semantic-ui-react";

interface AdminEditorSection { 
  title: string;
  description: string;
  active: boolean
  index: number;
  onClick: AccordionTitleProps['onClick']
}

export const AdminEditorSection:React.FC<AdminEditorSection> = ({
  title,
  description,
  active,
  children,
  index,
  onClick,
  }) => {
	return (
		<Accordion active={active} >
			<Accordion.Title active={active} index={index} onClick={onClick}>
				<h2>{title}</h2>
			</Accordion.Title>
			<Accordion.Content active={active} index={index}>
				<p>{description}</p>
				{children}
			</Accordion.Content>
		</Accordion>
	);
};




// WEBPACK FOOTER //
// ./src/pages/AdminEditor/AdminEditorSection.tsx